import { render, staticRenderFns } from "./DocPost.vue?vue&type=template&id=6f1cee04&scoped=true&"
import script from "./DocPost.vue?vue&type=script&lang=js&"
export * from "./DocPost.vue?vue&type=script&lang=js&"
import style0 from "./DocPost.vue?vue&type=style&index=0&id=6f1cee04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cee04",
  null
  
)

export default component.exports